import {
  type FeatureFlagConfig,
  type FeatureConfig,
} from '@platform/client/features';
import { initFeatureFlags } from '@platform/core/feature-flags';

export const initFeatures = (
  featureConfigs: FeatureConfig[],
  featureFlagConfigs: FeatureFlagConfig[],
) => {
  featureFlagConfigs.forEach(({ featureFlags }) =>
    initFeatureFlags(featureFlags),
  );

  const routes = featureConfigs.flatMap((feature) => feature.routes);

  return {
    featureConfigs,
    featureFlagConfigs,
    routes,
  };
};
